module.exports = __webpack_public_path__ + "img/taptap.d1153fc9.png";